import { render } from "./DigitalInnovationPage.vue?vue&type=template&id=678c367c"
import script from "./DigitalInnovationPage.vue?vue&type=script&lang=js"
export * from "./DigitalInnovationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__